export default __webpack_public_path__ + "static/media/between.c22f1230.svg";